import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { StorageKeysEnum } from './core/enums/storage.keys.enum';
import { FuseConfigService } from '../@fuse/services/config/config.service';
import { FuseConfig } from '../@fuse/services/config/config.types';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
    /**
     * Constructor
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
    ) {
    }

    ngOnInit(): void {
        const appConfig: FuseConfig = JSON.parse(localStorage.getItem(StorageKeysEnum.settings));
        if (appConfig) {
            this._fuseConfigService.config = appConfig;
        }
    }
}
